export default __webpack_public_path__ + "static/media/image30Sec.03fccffe.png";